const SECTOR_PROPOSALS_TAG_TYPES = {
  LIST: "SECTOR_PROPOSALS_LIST",
  DETAIL: "SECTOR_PROPOSALS_DETAIL",
  CREATE: "SECTOR_PROPOSALS_CREATE",
  APPROVE: "SECTOR_PROPOSALS_APPROVE",
  REJECT: "SECTOR_PROPOSALS_REJECT"
};

export const SECTOR_PROPOSALS_TAGS = Object.values(SECTOR_PROPOSALS_TAG_TYPES);
export default SECTOR_PROPOSALS_TAG_TYPES;

